const rotas = [
  {
    path: "diarios",
    name: "Diários de obra",
    component: () => import("./ListarTodos.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Dashboard",
      title: "Diários de obra",
      icon: "mdi-text-box-multiple-outline",
      subject: ["RDO"],
      action: ["read"],
      showMenu: true,
      grupo: "RDO",
      grupoTitle: "RDO",
    },
  },
  {
    path: "/:obra/diarios/configurar",
    name: "Configurar Diário",
    component: () => import("./ConfigurarDiario.vue"),
    meta: {
      breadcrumb: "Dashboard|Diários de obra",
      obraObrigatoria: true,
      title: "Configurar RDO",
      icon: "mdi-cog",
      subject: ["RDO"],
      action: ["config"],
      showMenu: true,
      grupo: "RDO",
      grupoTitle: "RDO",
    },
  },
  {
    path: "/:obra/diarios/datas",
    name: "Datas do Diário",
    component: () => import("./DatasDiario.vue"),
    meta: {
      breadcrumb: "Dashboard|Diários de obra",
      obraObrigatoria: true,
      title: "Datas do Diario",
      icon: "mdi-calendar-month",
      subject: ["RDO"],
      action: ["data_planejada"],
      showMenu: true,
      grupo: "RDO",
      grupoTitle: "RDO",
    },
  },
  {
    path: "/:obra/diarios/novo",
    name: "Novo Diário",
    component: () => import("./NovoDiario.vue"),
    meta: {
      breadcrumb: "Dashboard|Diários de obra",
      obraObrigatoria: true,
      title: "Novo RDO",
      icon: "mdi-plus",
      subject: ["RDO"],
      action: ["create"],
      // O item do menu só aparece para o site manager da obra (RDO-01).
      criaRdoNaObra: true,
      showMenu: true,
      grupo: "RDO",
      grupoTitle: "RDO",
    },
  },
  {
    path: "diarios/:diario",
    name: "Diário",
    component: () => import("./Diario.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Diários de obra",
      title: "Diário",
      icon: "mdi-text-box-multiple-outline",
      subject: ["RDO"],
      showMenu: false,
      grupo: "RDO",
      grupoTitle: "RDO",
    },
  },
  {
    path: "diarios/:diario/editar",
    name: "Editar Diário",
    component: () => import("./UpdateDiario.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Diários de obra",
      title: "Editar Diário",
      icon: "mdi-text-box-multiple-outline",
      subject: ["RDO"],
      action: ["update"],
      showMenu: false,
      grupo: "RDO",
      grupoTitle: "RDO",
    },
  },
  {
    path: "diarios/:diario/atualizar",
    name: "Atualizar Diário",
    component: () => import("./Diario.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Diários de obra|Diário",
      title: "Atualizar Diario",
      icon: "mdi-text-box-multiple-outline",
      subject: ["RDO"],
      action: ["update"],
      showMenu: false,
      grupo: "RDO",
      grupoTitle: "RDO",
    },
  },
];

export default rotas;
